import {
    TRIGGER_GET_ALL_PRODUCTS,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    COLLECT_AFYA_IMARA_QUOTE_FORM_DATA,
    COLLECT_PREMIUM_COMPARISON_DATA,
} from '../../../actions/afyaImara/quote';
import { getProductsService } from './products';
import { premiumCalculationService } from './premium';
import { getProductComparisonService } from './productComparison';
import { shareQuoteService } from './shareQuote';
import {
    TRIGGER_PAYMENTS_STK_PUSH,
    TRIGGER_CONFIRM_ORDER,
    CHECK_PAYMENTS_STATUS,
} from '../../../actions/afyaImara/payments';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { orderConfirmationService } from './orderConfirmation';

import { COLLECT_PAYLOAD_DATA } from '../../../actions/afyaImara/payloadCollection';
import { payloadSubmitService } from './payloadCollection';

import { COLLECT_LOGIN_DETAILS } from '../../../actions/afyaImara/auth';
import { loginService } from './login';

import { TRIGGER_AGENT_TYPE } from '../../../actions/afyaImara/agentModal';
import { getIntermeiaryAgent } from './agent';
import { TRIGGER_GET_NATIONALITIES } from '../../../actions/afyaImara/personalDetails';
import { getNationalityService } from './nationalities';

import { paystackPaymentService, submitPaymentService, paystackStkStatusService } from './paystack';

import {
    INITIATE_PAYMENT,
    PAYSTACK_SUBMIT_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
} from '../../../actions/afyaImara/paystack';

export const afyaImaraService = (store, next, action) => {
    if (action.type.startsWith(INITIATE_PAYMENT)) {
        return paystackPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT)) {
        return submitPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS)) {
        return paystackStkStatusService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_PRODUCTS)) {
        return getProductsService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_PREMIUM_COMPARISON_DATA)) {
        return getProductComparisonService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_AFYA_IMARA_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_AGENT_TYPE)) {
        return getIntermeiaryAgent(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_GET_NATIONALITIES)) {
        return getNationalityService(store, next, action);
    }
    return null;
};
